var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": !_vm.dataForm.id ? 'Add Office Address' : 'Edit Office Address',
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "900px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Entity type",
      "prop": "type"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select type"
    },
    model: {
      value: _vm.dataForm.type,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "type", $$v);
      },
      expression: "dataForm.type"
    }
  }, _vm._l(_vm.entityTypes, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Country",
      "prop": "country"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Country"
    },
    model: {
      value: _vm.dataForm.country,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "country", $$v);
      },
      expression: "dataForm.country"
    }
  }, _vm._l(_vm.countryList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1), !_vm.isMultiLineAddressCountry ? _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "address"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "type": "textarea",
      "rows": 5,
      "autosize": {
        minRows: 4
      },
      "resize": "none",
      "placeholder": "Address"
    },
    model: {
      value: _vm.dataForm.address,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "address", $$v);
      },
      expression: "dataForm.address"
    }
  })], 1) : _vm._e(), _vm.isMultiLineAddressCountry ? _c('el-form-item', {
    attrs: {
      "label": "Address Line1",
      "prop": "addressLine1"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "placeholder": "Address Line1"
    },
    model: {
      value: _vm.dataForm.addressLine1,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "addressLine1", $$v);
      },
      expression: "dataForm.addressLine1"
    }
  })], 1) : _vm._e(), _vm.isMultiLineAddressCountry ? _c('el-form-item', {
    attrs: {
      "label": "Address Line2",
      "prop": "addressLine2"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "placeholder": "Address Line2"
    },
    model: {
      value: _vm.dataForm.addressLine2,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "addressLine2", $$v);
      },
      expression: "dataForm.addressLine2"
    }
  })], 1) : _vm._e(), _vm.isMultiLineAddressCountry ? _c('el-form-item', {
    attrs: {
      "label": "Address Line3",
      "prop": "addressLine3"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "placeholder": "Address Line3"
    },
    model: {
      value: _vm.dataForm.addressLine3,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "addressLine3", $$v);
      },
      expression: "dataForm.addressLine3"
    }
  })], 1) : _vm._e(), _vm.isMultiLineAddressCountry ? _c('el-form-item', {
    attrs: {
      "label": "State",
      "prop": "state"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select State"
    },
    model: {
      value: _vm.dataForm.state,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "state", $$v);
      },
      expression: "dataForm.state"
    }
  }, _vm._l(_vm.stateOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1) : _vm._e(), _c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "city"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "placeholder": "City"
    },
    model: {
      value: _vm.dataForm.city,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "city", $$v);
      },
      expression: "dataForm.city"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "PostalCode",
      "prop": "postalCode"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "placeholder": "postalCode"
    },
    model: {
      value: _vm.dataForm.postalCode,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "postalCode", $$v);
      },
      expression: "dataForm.postalCode"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Supplier",
      "prop": "supplierId"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.supplierId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "supplierId", $$v);
      },
      expression: "dataForm.supplierId"
    }
  }, _vm._l(_vm.supplierList, function (item) {
    return _c('el-option', {
      key: "supplier-".concat(item.id),
      attrs: {
        "label": item.companyName,
        "value": item.id
      }
    });
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Status",
      "prop": "status"
    }
  }, [_c('el-radio-group', {
    model: {
      value: _vm.dataForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "status", $$v);
      },
      expression: "dataForm.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("Disable")]), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("Enable")])], 1)], 1)], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("Submit")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }